import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=8d06ce92&scoped=true&"
import script from "./NotificationBell.vue?vue&type=script&lang=js&"
export * from "./NotificationBell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=8d06ce92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d06ce92",
  null
  
)

export default component.exports